import React from "react";
import UserRow from "./UserRow";
import UserCard from "./UserCard";

const UsersTable = ({ users, isLoaded, toRemove, onAction, searchKey, t }) => {
    // Filter users locally if search key exists
    const getFilteredUsers = () => {
        if (!users || users.length === 0) return [];
        if (!searchKey) return users;

        return users.filter(
            (v) =>
                v.Name.toLowerCase().includes(searchKey.toLowerCase()) ||
                v.Username.toLowerCase().includes(searchKey.toLowerCase()) ||
                (v.Phone && v.Phone.includes(searchKey)) ||
                (v.Email && v.Email.toLowerCase().includes(searchKey.toLowerCase()))
        );
    };

    const filteredUsers = isLoaded ? getFilteredUsers() : [];

    const renderEmptyState = (icon, title, subtitle) => (
        <div className="users-empty-state">
            <div className="users-empty-icon">
                <i className={icon}></i>
            </div>
            <div className="users-empty-title">{title}</div>
            {subtitle && <div className="users-empty-subtitle">{subtitle}</div>}
        </div>
    );

    // Loading state
    if (!isLoaded) {
        return (
            <div className="users-table-wrapper">
                {renderEmptyState(
                    "fad fa-sync-alt fa-spin",
                    t("Pages.UsersControl.Loading"),
                    null
                )}
            </div>
        );
    }

    // No users at all
    if (!users || users.length === 0) {
        return (
            <div className="users-table-wrapper">
                {renderEmptyState(
                    "fad fa-telescope",
                    t("Pages.UsersControl.NotFound"),
                    null
                )}
            </div>
        );
    }

    // Search returned nothing
    if (filteredUsers.length === 0) {
        return (
            <div className="users-table-wrapper">
                {renderEmptyState(
                    "fad fa-telescope",
                    t("Pages.UsersControl.NotFound"),
                    `"${searchKey}" ${t("Pages.UsersControl.IsNotHere")}`
                )}
            </div>
        );
    }

    return (
        <div className="users-table-wrapper">
            {/* Desktop Table */}
            <div className="users-table-scroll">
                <table className="users-table">
                    <thead>
                        <tr className="text-right">
                            <th>{t("Pages.UsersControl.tableHeaders.name")}</th>
                            <th>{t("Pages.UsersControl.tableHeaders.contact")}</th>
                            <th className="text-center">{t("Pages.UsersControl.tableHeaders.role")}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredUsers.map((user) => {
                            const isQueuedForRemoval = toRemove && toRemove.includes(user.Id);
                            if (isQueuedForRemoval) return null;
                            return (
                                <UserRow
                                    key={user.Id}
                                    item={user}
                                    t={t}
                                    onAction={onAction}
                                />
                            );
                        })}
                    </tbody>
                </table>
            </div>

            {/* Mobile Cards */}
            <div className="users-cards-list">
                {filteredUsers.map((user) => {
                    const isQueuedForRemoval = toRemove && toRemove.includes(user.Id);
                    if (isQueuedForRemoval) return null;
                    return (
                        <UserCard
                            key={user.Id}
                            item={user}
                            t={t}
                            onAction={onAction}
                        />
                    );
                })}
            </div>
        </div>
    );
};

export default UsersTable;
